const TEXT: Record<string, string> = {
  payment_unconfirmed: "This payment is not confirmed yet.",
  payment_member_mismatch: "This payment belongs to a different member.",
  payment_underpaid: "This payment is less than the re-issue fee.",
  payment_currency: "This payment is in the wrong currency.",
  payment_used: "This payment already covers another re-issue.",
  payment_purpose: "This is not a re-issue payment.",
  affidavit_required: "Confirm you have seen and checked the affidavit.",
  waiver_reason_short: "Give a waiver reason of at least 10 characters.",
  fee_choice: "Choose a payment or waive the fee.",
};

export function reissueIssueText(issue: string): string {
  return TEXT[issue] ?? issue;
}
